import Select, { MultiValue } from "react-select";
import styled from "styled-components";
import { useReactSelectTheme } from "@bagel-web/components";

import { decodeFilterOptions } from "./filterOptions";

export type FunctionResultSelectProps = {
  value: string | null;
  onChange: (e: { target: { value: string } }) => void;
  autoFocus?: boolean;
};

const RESULT_TYPE_OPTIONS = [
  {
    value: "success",
    label: "Success",
  },
  {
    value: "failure",
    label: "Failure",
  },
  {
    value: "warning",
    label: "Warning",
  },
  {
    value: "update",
    label: "Update",
  },
  {
    value: "none",
    label: "None",
  },
];

const SelectContainer = styled.div`
  width: 400px;
`;

const FunctionResultSelect = ({
  value,
  onChange,
  autoFocus,
}: FunctionResultSelectProps) => {
  return (
    <SelectContainer>
      <Select
        value={decodeFilterOptions(value)}
        isMulti={true}
        theme={useReactSelectTheme()}
        options={RESULT_TYPE_OPTIONS}
        autoFocus={autoFocus}
        onChange={(value: MultiValue<{ value: string }>) => {
          onChange({
            target: { value: value.length > 0 ? JSON.stringify(value) : "" },
          });
        }}
      />
    </SelectContainer>
  );
};

export default FunctionResultSelect;
